module.exports = __webpack_public_path__ + "static/media/authorinfo.83af3de1.png";